import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { useIntl } from 'react-intl';
import FacilitiesMapEditor from '../components/stateful/FacilitiesMapEditor';
import PrimaryFacilityQuery from '../components/stateful/PrimaryFacilityQuery';

export const GET_PRIMARY_FACILITY = gql`
  query GetFacilitiesMapEditorPrimaryFacility($id: ID!, $locale: String!) {
    facility(id: $id) {
      id
      ...FacilitiesMapEditorFacility
    }
  }

  ${FacilitiesMapEditor.fragments.facility}
`;

const propTypes = {
  primaryFacilityId: PropTypes.string,
};

const defaultProps = {
  primaryFacilityId: undefined,
};

const FacilitiesMapEditorPrimaryFacility = ({
  primaryFacilityId,
  ...rest
}) => {
  const { locale } = useIntl();
  return (
    <PrimaryFacilityQuery
      {...rest}
      primaryFacilityId={primaryFacilityId}
      query={GET_PRIMARY_FACILITY}
      variables={{ id: primaryFacilityId, locale }}
    />
  );
};

FacilitiesMapEditorPrimaryFacility.propTypes = propTypes;
FacilitiesMapEditorPrimaryFacility.defaultProps = defaultProps;

export default FacilitiesMapEditorPrimaryFacility;
